/**
 * @desc 更新
 */
import { MemberGroupEntity } from '@eastcoal/api/auth/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type UpdateMemberGroupParameter = MemberGroupEntity

const method = 'PUT'
const url = '/auth/group'

export const updateMemberGroupApi = (
  data?: UpdateMemberGroupParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<MemberGroupEntity>({
    method,
    url,
    data,
    ...config
  })
}

updateMemberGroupApi.method = method
updateMemberGroupApi.url = url
